
import { defineComponent, onMounted } from 'vue'
import TrinketGrid from '@/components/TrinketGrid/TrinketGrid.vue'
import SettingsModal from '@/components/Modal/SettingsModal/SettingsModal.vue'
import Toast from '@/components/Common/Toast.vue'
import MainToolbar from '@/components/Toolbar/MainToolbar.vue'
import Footer from '@/components/Footer/Footer.vue'
import { useStore } from '@/store'
import { PaletteStorageName, TrinketGridStorageName } from '@/store/state'

export default defineComponent({
    name: 'App',
    components: { Footer, MainToolbar, Toast, SettingsModal, TrinketGrid },
    setup () {
        const store = useStore()

        const savedTrinket = localStorage.getItem(TrinketGridStorageName)
        const palette = localStorage.getItem(PaletteStorageName)

        if (savedTrinket) {
            store.dispatch('loadTrinket', savedTrinket)
        }

        if (palette) {
            store.dispatch('loadPalette', palette)
        }

        onMounted(() => {
            // Handle autosave
            store.dispatch('updateAutoSaveConfiguration', {})
            // Save on exit or reload
            store.dispatch('updateSaveOnExitConfiguration', store.state.configuration.saving.saveOnExit)
        })
    }
})
